
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"tag"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.884 2.133v5.214a2.5 2.5 0 00.732 1.768l9.634 9.635a1.25 1.25 0 001.768 0l5.732-5.733a1.25 1.25 0 000-1.768L9.116 1.615A2.5 2.5 0 007.348.883H2.134a1.25 1.25 0 00-1.25 1.25v0z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.01 5.258a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    